module.exports = __webpack_public_path__ + "img/deal.647eeebb.svg";